/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import RegularTemplate from '@/components/templates/RegularTemplate'
import { useSelectItems } from '@/hooks/items/useSelectItems'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import ModalAsset from './components/Modal'
import {
  BROWSE_ASSET_LISTINGS,
  BROWSE_ASSET_LISTINGS_DESCRIPTION
} from '@/configs/strings/asset-licenses.strings'
import { getListedAssets } from '@/services/listed-assets'
import AssetListingsToggle from './components/AssetListingsToggle'

const AssetLicensesList = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const [assetIdSelected, setAssetIdSelected] = useState()
  const {
    itemsResponse,
    loading,
    onChangePage,
    page,
    reloadItems,
    searchParams,
    setSearchParams,
    totalPages
  } = useFetchItemsWithParamsV2({
    fetchService: getListedAssets
  })
  const {
    itemsSelected,
    clearSelectedItems,
    selectOneItem
  } = useSelectItems({
    items: itemsResponse?.assets,
    excludeByProperty: 'licensed',
    mapSelectAllItems: item => item.id
  })
  const onPurchaseLicense = async (assetId) => {
    selectOneItem(assetId)
    setAssetIdSelected(assetId)
    setModalIsVisible(true)
  }

  return (
    <RegularTemplate
      title={BROWSE_ASSET_LISTINGS}
      description={BROWSE_ASSET_LISTINGS_DESCRIPTION}
      loadingScreen={isProcessing}
    >
      { itemsResponse &&
        <>
          <AssetListingsToggle
            assets={itemsResponse.assets}
            isLoading={loading}
            itemsLayout={searchParams.itemsLayout}
            onChangePage={onChangePage}
            onFilterResults={(filter) => setSearchParams(filter)}
            onPurchaseLicense={onPurchaseLicense}
            onReset={() => setSearchParams({})}
            page={page}
            searchParams={searchParams}
            totalAssets={itemsResponse.total}
            totalPages={totalPages}
          />
          { modalIsVisible &&
            <ModalAsset
              active={true}
              clearSelectedAssets={clearSelectedItems}
              assetIdSelected={assetIdSelected}
              assets={itemsSelected}
              reloadItems={reloadItems}
              setIsProcessing={setIsProcessing}
              setModalIsVisible={setModalIsVisible}
            />
          }
        </>
      }
    </RegularTemplate>
  )
}

export default AssetLicensesList
